import { createFileRoute } from '@tanstack/react-router';

import { CalendarPage } from '@/views/admin/calendar/calendar-page.tsx';

export const Route = createFileRoute('/admin/calendar')({
  component: CalendarPage,
});
